import { InvokeHubs, Hubs as namesHub } from '@/plugins/enums/index.js';

import { hub } from '@/plugins/signalR/index';


async function allDocumentsSignalRInvoke(initDate, finalDate) {
    let request = { initDate: initDate, finalDate: finalDate };

    try {
        let connection = hub.getInstance(namesHub.documentHub)
        await connection.start();

        //envia la peticion
        await connection.invoke(InvokeHubs.allDocumentsByDate, request);
    } catch (err) {
        console.log("Error en la gráfica por tipos", err);
    }
}

async function countDenunciationsSignalRInvoke(initDate, finalDate) {
    let request = { initDate: initDate, finalDate: finalDate };

    try {
        let connection = hub.getInstance(namesHub.denunciationHub)
        await connection.start();

        //envia la peticion
        await connection.invoke(InvokeHubs.countDenunciations, request);
    } catch (err) {
        console.log("Error en la gráfica de denuncias entro", err);
    }
}

async function countDocumentsSignalRInvoke(initDate, finalDate) {
    let request = { initDate: initDate, finalDate: finalDate };
    
    try {
        let connection = hub.getInstance(namesHub.documentHub)
        await connection.start();

        //envia la peticion
        await connection.invoke(InvokeHubs.countDocuments, request);
    } catch (err) {
        console.log("Error en la gráfica de documentos", err);
    }
}

async function countSendDenunciationSignalRInvoke(initDate, finalDate) {
    let request = { initDate: initDate, finalDate: finalDate };

    try {
        const connection = hub.getInstance(namesHub.sendDenunciationHub)
        await connection.start();

        //envia la peticion
        await connection.invoke(InvokeHubs.countSendDenunciation, request);
    } catch (err) {
        console.log("Error en la gráfica de notificación denuncia: ", err);
    }
}

async function countSendDocumentsSignalRInvoke(initDate, finalDate) {
    let request = { initDate: initDate, finalDate: finalDate };

    try {
        const connection = hub.getInstance(namesHub.sendDocumentHub)
        await connection.start();

        //envia la peticion
        await connection.invoke(InvokeHubs.countSendDocuments, request);
    } catch (err) {
        console.log("Error en la gráfica de notificación de documentos", err);
    }
}

async function countMeetsSignalRInvoke(initDate, finalDate) {
    let request = { initDate: initDate, finalDate: finalDate };

    try {
        const connection = hub.getInstance(namesHub.meetHub)
        await connection.start();

        //envia la peticion
        await connection.invoke(InvokeHubs.countMeets, request);
    } catch (err) {
        console.log("Error en la gráfica de meets", err);
    }
}

async function countStatementsSignalRInvoke(initDate, finalDate) {
    let request = {initDate: initDate, finalDate: finalDate};

    try {
        const connection = hub.getInstance(namesHub.statementHub)
        await connection.start();

        await connection.invoke(InvokeHubs.countStatements, request);
    } catch (err) {
        console.log("Error en la gráfica de declaraciones", err);
    }
}

async function countSendStatementsSignalRInvoke(initDate, finalDate) {
    let request = {initDate: initDate, finalDate: finalDate};

    try {
        const connection = hub.getInstance(namesHub.sendStatementHub)
        await connection.start();

        await connection.invoke(InvokeHubs.countSendStatements, request);
    } catch (err) {
        console.log("Error en la gráfica de notificaciones de declaraciones", err);
    }
}

async function countKarinDenunciationsSignalRInvoke(initDate, finalDate) {
    let request = {initDate: initDate, finalDate: finalDate};

    try {
        const connection = hub.getInstance(namesHub.karinDenunciationHub)
        await connection.start();

        await connection.invoke(InvokeHubs.countKarinDenunciation, request);
    } catch (err) {
        console.log("Error en la gráfica de denuncias de Karin", err);
    }
}

export {
    allDocumentsSignalRInvoke,
    countDenunciationsSignalRInvoke,
    countDocumentsSignalRInvoke,
    countSendDenunciationSignalRInvoke,
    countSendDocumentsSignalRInvoke,
    countMeetsSignalRInvoke,
    countStatementsSignalRInvoke,
    countSendStatementsSignalRInvoke,
    countKarinDenunciationsSignalRInvoke
}
